module.exports = __webpack_public_path__ + "img/numberly-international.5155993a.svg";